import {compact, find, flatten, map, size, values} from 'lodash';
import {useForm} from 'react-hook-form';

import GeneControl from 'components/GenotypePicker/GeneControl';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';

import './GeneControl.scss';

export default function GenotypePickerForm({options, className, annotationId, chemicalId, onSuccess,
  values: initValues}) {
  const appContext = useAppContext();
  const {
    handleSubmit,
    control,
    setError,
    formState: { errors },
  } = useForm({values: initValues});

  const onSubmit = async (formData) => {
    // validate that at least some data is present
    if (size(compact(flatten(values(formData)))) === 0) {
      setError(
        'root',
        {type: 'missing-data', message: 'Invalid: must specify at least one genotype or phenotype'});
      return;
    }

    try {
      const r = await appContext.api.post(
        `site/gsi/${annotationId}/${chemicalId}`,
        {json: formData, parseJson: true},
      );
      onSuccess(find(values(r?.data?.drugs), (d) => d.drug.id === chemicalId) || null);
    } catch (err) {
      appContext.toastError(<KyError kyError={err} />);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={className}>
      <div className="gene-control">
        {map(options, (option) => {
          const {genesymbol, alleles, phenotypeOptionMap: phenos, allowSingleAllele, displaySingleAllele} = option;
          return <GeneControl key={genesymbol} name={genesymbol} alleles={alleles} phenotypes={phenos} control={control} displaySingleAllele={displaySingleAllele} allowSingleAllele={allowSingleAllele} />;
        })}
      </div>
      <input className="btn btn-primary mt-2" type="submit" value="Find Results" />
      {errors?.root && <div className="text-danger">{errors.root.message}</div>}
    </form>
  );
}
